// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"374":"teachersparents","548":"businesspartners","884":"iamstudent","931":"termsconditions","961":"careerrepresentative","965":"aboutus"}[chunkId] + "." + {"374":"525b8182","548":"5904a69e","884":"32954657","931":"56c6766a","961":"05850657","965":"54db87ff"}[chunkId] + ".css";
};